module.exports = new __parcel__URL__("linked-in.aac163ce.svg").toString();